import { getGtmClient } from 'marketing-site/lib/gtm'
import { ValidationFunction, ValidatorValue } from './Validator.interface'

export const WRONG_BUSINESS_EMAIL_ERROR = 'Please enter a business email address.'
export const IsBusinessEmailValidator =
  (error = WRONG_BUSINESS_EMAIL_ERROR): ValidationFunction =>
  async (value: ValidatorValue) => {
    if (!value || typeof value !== 'string') {
      return error
    }

    const gtmClient = await getGtmClient()
    if (await gtmClient.personalEmailDomain(value)) {
      return error
    }

    return ''
  }
